import React, { useEffect } from "react";
import { Button } from "antd";
import { Container } from "./styles";
import { isMobile } from "../../utils";
import { useFab } from "../../contexts/FabContext";

export interface IVideoTutorial {
  id: string;
  url: string;
  headline: string;
}

export const videosTutoriais: IVideoTutorial[] = [
  {
    id: "dependentes-4",
    url: "https://www.youtube.com/embed/abDXvOcXbiU",
    headline: "Cadastrar dependentes"
  },
  {
    id: "identificacao-6",
    url: "https://www.youtube.com/embed/l7RF8JJyU24",
    headline: "Identificação"
  },
  {
    id: "identificacao-7",
    url: "https://www.youtube.com/embed/A23Pg_o3Zuw",
    headline: "Como Integrar o Arquivo do Ano Passado"
  },
  {
    id: "alimentandos-8",
    url: "https://www.youtube.com/embed/U_WcVbXJBnA",
    headline: "Como Declarar Alimentandos"
  },
  {
    id: "renda-9",
    url: "https://www.youtube.com/embed/rGOwf2xLSHU",
    headline: "Como Declarar Salário"
  },
  {
    id: "bolsa-10",
    url: "https://www.youtube.com/embed/kbAs1zYAtPs",
    headline: "Como Declarar Posições Bolsa de Valores"
  },
  {
    id: "crypto-11",
    url: "https://www.youtube.com/embed/PbT4W1Ulin4",
    headline: "Como Declarar Posições Cripto"
  },
  {
    id: "exterior-12",
    url: "https://www.youtube.com/embed/WTCieQEXRI4",
    headline: "Como Declarar Posições Exterior"
  },
  {
    id: "imoveis-13",
    url: "https://www.youtube.com/embed/0UqeE9ldb-0",
    headline: "Como Declarar Imóveis"
  },
  {
    id: "automoveis-14",
    url: "https://www.youtube.com/embed/pKVIKfmQ2Wo",
    headline: "Como Declarar Automóveis"
  },
  {
    id: "aplicacoes-15",
    url: "https://www.youtube.com/embed/ih6NTiXe6A4",
    headline: "Como Declarar Aplicações Financeiras"
  },
  {
    id: "op-bolsa-16",
    url: "https://www.youtube.com/embed/RjCsfHJxGyA",
    headline: "Como Declarar Operações Bolsa de Valores"
  },
  {
    id: "op-crypto-17",
    url: "https://www.youtube.com/embed/YOIvYyIl9fY",
    headline: "Como Declarar Operações Cripto"
  },
  {
    id: "op-exterior-18",
    url: "https://www.youtube.com/embed/qGk0AY3u3vA",
    headline: "Como Declarar Operações Exterior"
  },
  {
    id: "despesas-dedutiveis-19",
    url: "https://www.youtube.com/embed/XbIMvcOs2rc",
    headline: "Como Declarar Despesas com Educação"
  },
  {
    id: "despesas-dedutiveis-20",
    url: "https://www.youtube.com/embed/waQ-IRyKHi4",
    headline: "Como Declarar Despesas Médicas"
  },
  {
    id: "rendimentos-mensais-21",
    url: "https://www.youtube.com/embed/DA1U4nSnRG8",
    headline: "Como Declarar Rendimentos Mensais"
  },
  {
    id: "empresarios-22",
    url: "https://www.youtube.com/embed/_Yodw6Wn5Ek",
    headline: "Como Declarar Rendimentos como Empresário"
  },
  {
    id: "emprestimos-23",
    url: "https://www.youtube.com/embed/p_IC4Hla8K0",
    headline: "Como Declarar Empréstimos"
  },
  {
    id: "previdencia-privada-24",
    url: "https://www.youtube.com/embed/qazY9q-OHQg",
    headline: "Como Declarar Previdência Privada"
  },
  {
    id: "irpf-25",
    url: "https://www.youtube.com/embed/YlSL8jbHlrw",
    headline: "Como Fazer o Upload no Programa da Receita"
  }
];

interface IVideoTutorialProps {
  videoTutorial: IVideoTutorial | null;
}

const VideoTutorial: React.FC<IVideoTutorialProps> = ({ videoTutorial }) => {
  const { showVideo, setShowVideo } = useFab();

  useEffect(() => {
    videoTutorial !== null ? setShowVideo(true) : setShowVideo(false);
  }, [videoTutorial, setShowVideo]);

  return showVideo && videoTutorial !== null && !isMobile() ? (
    <Container
      id="divVideoTutorial"
      style={
        videoTutorial.id === "irpf-25"
          ? { bottom: "0px", right: "120px" }
          : { top: "110px", right: 0 }
      }
    >
      <Button size="small" onClick={() => setShowVideo(false)}>
        X
      </Button>
      <iframe
        id={videoTutorial.id}
        title={videoTutorial.headline}
        src={videoTutorial.url}
        width="350"
        height="190"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen={true}
      />
    </Container>
  ) : null;
};

export default VideoTutorial;
